import { call, put, takeEvery } from 'redux-saga/effects';
import { getDashboardStatsApi, getMonthlyScanStatsApi } from '../../api/dashboardApi/dashboardApi';
import {
  GET_DASHBOARD_STATS_REQUEST,
  GET_DASHBOARD_STATS_SUCCESS,
  GET_DASHBOARD_STATS_FAILURE,
  GET_MONTHLY_SCAN_STATS_REQUEST,
  GET_MONTHLY_SCAN_STATS_SUCCESS,
  GET_MONTHLY_SCAN_STATS_FAILURE
} from '../../constants/dashboardConstant/dashboardConstants';

function* getDashboardStatsSaga(action) {
  try {
    const { oemId, month } = action.payload;
    const response = yield call(getDashboardStatsApi, oemId, month);
    yield put({ type: GET_DASHBOARD_STATS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: GET_DASHBOARD_STATS_FAILURE, payload: error.message });
  }
}

function* getMonthlyScanStatsSaga(action) {
  try {
    const oemId = action.payload;
    const response = yield call(getMonthlyScanStatsApi, oemId);
    yield put({ type: GET_MONTHLY_SCAN_STATS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: GET_MONTHLY_SCAN_STATS_FAILURE, payload: error.message });
  }
}

export default function* dashboardSaga() {
  yield takeEvery(GET_DASHBOARD_STATS_REQUEST, getDashboardStatsSaga);
  yield takeEvery(GET_MONTHLY_SCAN_STATS_REQUEST, getMonthlyScanStatsSaga);
}